<template>
    <div class="button" @click="showModal()">予約する</div>
    <div class="form" v-if="show">
        <div class="box">
            <div class="header">
                <h2>店舗予約</h2>
                <div class="close" @click="closeModal()"></div>
            </div>
            <ol class="stepper">
                <li :class="index===0?'active':''">入力</li>
                <li :class="index===1?'active':''">確認</li>
                <li :class="index===2?'active':''">完了</li>
            </ol>
            <div ref="slider" class="contents keen-slider">
                <div class="reserveForms">
                    <div class="inputs">
                        <h3>店舗名</h3>
                        <p>{{ shop.name }}</p>
                        <h3>ご利用希望のクーポン</h3>
                        <label>
                            <input type="radio" v-model="coupon_flg" name="coupon_flg" value="true">
                            クーポンを使用（併用不可）
                        </label>
                        <select v-show="coupon_flg === 'true'" v-model="params.coupon_id" name="coupon_id" :class="{ 'error': errors.coupon_id }">
                            <option value="" disabled selected>選択してください</option>
                            <option v-for="coupon in coupons" :value="coupon.id">{{ coupon.title }}</option>
                        </select>
                        <label>
                            <input type="radio" v-model="coupon_flg" name="coupon_flg" value="false">
                            使用しない
                        </label>
                        <p v-for="error in errors.coupon_id" class="formError">{{ error }}</p>
                        <h3>予約人数</h3>
                        <select v-model="params.number" name="number">
                            <option value="" disabled selected>ご来店人数をお選びください</option>
                            <option v-for="n in 20" :value="n">{{ n }}</option>
                        </select>
                        <p v-for="error in errors.number" class="formError">{{ error }}</p>
                        <h3>予約日時</h3>
                        <label class="required">第1希望</label>
                        <input type="text" v-model="params.first_selected_date" name="first_selected_date" onfocus="this.type='date'" onfocusout="this.type='text'" placeholder="ご来店日をお選びください" :class="{'error': errors.first_selected_date}">
                        <input type="text" v-model="params.first_selected_time" name="first_selected_time" onfocus="this.type='time'" step="900" min="06:00" onfocusout="this.type='text'" placeholder="ご来店時間をお選びください" :class="{'error': errors.first_selected_time}">
                        <p v-for="error in errors.first_selected_date" class="formError">{{ error }}</p>
                        <label class="optional">第2希望</label>
                        <input type="text" v-model="params.second_selected_date" name="second_selected_date" onfocus="this.type='date'" onfocusout="this.type='text'" placeholder="ご来店日をお選びください">
                        <input type="text" v-model="params.second_selected_time" name="second_selected_time" onfocus="this.type='time'" step="900" min="06:00" onfocusout="this.type='text'" placeholder="ご来店時間をお選びください">
                        <p v-for="error in errors.second_selected_date" class="formError">{{ error }}</p>

                        <h3>お客様情報</h3>
                        <label class="required">氏名</label>
                        <div class="textRow">
                            <input type="text" v-model="params.last_name" name="last_name" placeholder="例）田中" :class="{ 'error': errors.name }">
                            <input type="text" v-model="params.first_name" name="first_name" placeholder="例）あおい" :class="{ 'error': errors.name }">
                        </div>
                        <p v-for="error in errors.name" class="formError">{{ error }}</p>
                        <label class="required">氏名（ローマ字）</label>
                        <div class="textRow">
                            <input type="text" v-model="params.last_name_romaji" name="last_name_romaji" placeholder="例）TANAKA" :class="{ 'error': errors.name_romaji }">
                            <input type="text" v-model="params.first_name_romaji" name="first_name_romaji" placeholder="例）AOI" :class="{ 'error': errors.name_romaji }">
                        </div>
                        <p v-for="error in errors.name_romaji" class="formError">{{ error }}</p>
                        <label class="required">電話番号</label>
                        <input type="text" v-model="params.tel" name="tel" placeholder="例）00000000000" :class="{ 'error': errors.tel }">
                        <p v-for="error in errors.tel" class="formError">{{ error }}</p>
                        <label class="required">メールアドレス</label>
                        <input type="text" v-model="params.email" name="email" placeholder="例）mail@example.com" :class="{ 'error': errors.email }">
                        <p v-for="error in errors.email" class="formError">{{ error }}</p>
                        <label class="required">メールアドレス（確認用）</label>
                        <input type="text" v-model="email_confirmation" name="confirmation" placeholder="もう一度入力してください" :class="{ 'error': errors.email_confirmation }">
                        <p v-for="error in errors.email_confirmation" class="formError">{{ error }}</p>
                        <label class="required">宿泊先名</label>
                        <input type="text" v-model="params.hotel_name" name="hotel_name" placeholder="例）◯◯ホテル" :class="{ 'error': errors.hotel_name }">
                        <p v-for="error in errors.hotel_name" class="formError">{{ error }}</p>
                        <label class="optional">その他のご希望</label>
                        <textarea v-model="params.other_request" name="other_request" cols="30" rows="10" placeholder="入力してください"></textarea>
                        <p v-for="error in errors.other_request" class="formError">{{ error }}</p>

                        <div v-show="shop.question1 || shop.question2 || shop.question3">
                            <h3>店舗からのお客様へのご質問</h3>
                            <div v-show="shop.question1">
                                <label for="">{{ shop.question1 }}</label>
                                <input type="text" v-model="params.question1" name="question1" placeholder="入力してください">
                            </div>
                            <div v-show="shop.question2">
                                <label for="">{{ shop.question2 }}</label>
                                <input type="text" v-model="params.question2" name="question2" placeholder="入力してください">
                            </div>
                            <div v-show="shop.question3">
                                <label for="">{{ shop.question3 }}</label>
                                <input type="text" v-model="params.question3" name="question3" placeholder="入力してください">
                            </div>
                        </div>
                        <div v-show="shop.request">
                            <h3>店舗からのお客様へのお願い</h3>
                            <p>{{ shop.request }}</p>
                            <label>
                                <input type="checkbox" v-model="request_flg" name="request_flg">
                                店舗からのお願いを確認しました。
                            </label>
                            <p v-for="error in errors.request_flg" class="formError">{{ error }}</p>
                        </div>
                    </div>
                    <div class="next">
                        <div class="button" @click="next(1)">予約内容を確認する</div>
                    </div>
                </div>
                <div class="confirm">
                    <div class="inputs">
                        <div class="heading">
                            <h3>まだ予約は完了していません</h3>
                            <p>ご予約内容の最終確認をしてください</p>
                        </div>
                        <h3>ご予約内容</h3>
                        <table>
                            <tr>
                                <th>店舗名</th>
                                <td>{{ shop.name }}</td>
                            </tr>
                            <tr v-show="params.coupon_id">
                                <th>ご利用希望のクーポン</th>
                                <td>{{ coupon_title }}</td>
                            </tr>
                            <tr>
                                <th>人数</th>
                                <td>{{ params.number }}</td>
                            </tr>
                            <tr>
                                <th>予約日時</th>
                                <td>
                                    <h4>第1希望</h4>
                                    <p>{{ params.first_preferred_date }}</p>
                                    <h4 v-show="params.second_preferred_date">第2希望</h4>
                                    <p>{{ params.second_preferred_date }}</p>
                                </td>
                            </tr>
                        </table>
                        <h3>お客様情報</h3>
                        <table>
                            <tr>
                                <th>氏名</th>
                                <td>{{ params.last_name }} {{ params.first_name }}</td>
                            </tr>
                            <tr>
                                <th>氏名（ローマ字）</th>
                                <td>{{ params.last_name_romaji }} {{ params.first_name_romaji }}</td>
                            </tr>
                            <tr>
                                <th>電話番号</th>
                                <td>{{ params.tel }}</td>
                            </tr>
                            <tr>
                                <th>メールアドレス</th>
                                <td>{{ params.email }}</td>
                            </tr>
                            <tr>
                                <th>宿泊先名</th>
                                <td>{{ params.hotel_name }}</td>
                            </tr>
                            <tr v-show="params.other_request">
                                <th>その他のご希望</th>
                                <td>{{ params.other_request }}</td>
                            </tr>
                        </table>
                        <div v-show="shop.question1 || shop.question2 || shop.question3">
                            <h3>店舗からお客様へのご質問</h3>
                            <table>
                                <tr v-show="shop.question1">
                                    <th>{{ shop.question1 }}</th>
                                    <td>{{ params.question1 }}</td>
                                </tr>
                                <tr v-show="shop.question2">
                                    <th>{{ shop.question2 }}</th>
                                    <td>{{ params.question2 }}</td>
                                </tr>
                                <tr v-show="shop.question3">
                                    <th>{{ shop.question3 }}</th>
                                    <td>{{ params.question3 }}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="notice">
                            <h4>注意事項</h4>
                            <p>※ご予約はまだ確定しておりません。店舗からの予約完了メールが届いて、はじめて予約完了となります。</p>
                            <p>※必ずPCメールアドレスをご記入ください。携帯メールアドレス（docomoやsoftbankなど）では海外からのメールが受信拒否され、メールが届かない可能性がございます。</p>
                            <p>※メールを送信してから48時間経っても返信がない場合は、恐れ入りますが、店舗宛にメールを再送いただくか、お電話にてお問い合わせください。</p>
                        </div>
                        <div class="button outlined fix confirm" @click="prev(0)">入力内容を変更する</div>
                    </div>
                    <div class="next">
                        <div class="terms">
                            <a href="/privacy_policy" target="_blank" rel="noopener">プライバシーポリシー</a>
                            及び
                            <a href="/tos" target="_blank" rel="noopener">利用規約</a>
                        </div>
                        <div class="button submitButton" :class="{ 'disabled': disabled_flg }" @click="next(2)">上記に同意の上、送信する</div>
                    </div>
                </div>
                <div class="complete">
                    <div class="icon"></div>
                    <h3>ご予約ありがとうございました</h3>
                    <p>ご来店をお待ちしております。</p>
                    <div class="button outlined"><a href="">店舗トップへ戻る</a></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        shop: Object,
        coupons: Array
    },
    data () {
        return {
            show: false,
            slide: null,
            index: 0,
            params: {
                shop_id: '',
                user_id: '',
                coupon_id: '',
                number: '',
                status: 1,
                first_selected_date: '',
                first_selected_time: '',
                first_preferred_date: '',
                second_selected_date: '',
                second_selected_time: '',
                second_preferred_date: '',
                last_name: '',
                first_name: '',
                last_name_romaji: '',
                first_name_romaji: '',
                email: '',
                tel: '',
                hotel_name: '',
                other_request: '',
                question1: '',
                question2: '',
                question3: '',
            },
            coupon_title: '',
            email_confirmation: '',
            coupon_flg: 'false',
            request_flg: false,
            disabled_flg: false,
            errors: {}
        }
    },
    mounted () {
        const reservation = document.querySelector('.reservation')
        if (reservation) {
            this.params.shop_id = this.shop.id
            this.initSlide()
        }
    },
    methods: {
        showModal() {
            const topSlider = document.querySelectorAll('.topSlider')[0]
            if (topSlider) {
                topSlider.classList.add('hidden')
            }
            this.show = true
            this.errors = {}
        },
        closeModal() {
            const topSlider = document.querySelectorAll('.topSlider')[0]
            if (topSlider) {
                topSlider.classList.remove('hidden')
            }
            this.show = false
        },
        initSlide () {
            const sliderUl = this.$refs.slider
            if (!sliderUl) return
            const childrenArray = Array.from(sliderUl.children)
            this.slide = KeenSlider(this.$refs.slider, {
                initial: this.index,
                drag: false,
                slides: {
                    perView: 1
                },
                selector: childrenArray
            })
            this.slide.on('slideChanged', (instance) => {
                const current = instance.track.details.abs
                this.index = current
            })
        },
        async next(number) {
            // 予約内容確認ページ遷移前にバリデーションチェックを挟む
            if (number === 1) {
                let res = await this.checkValidation()
                if (res) {
                    this.slide.next('slideChanged', () => {
                        this.index = number
                    })
                }
            }
            if (number === 2) {
                await this.save(number)
            }
        },
        prev(number) {
            this.slide.prev('slideChanged', () => {
                this.index = number
            })
        },
        async save(number) {
            // 店舗予約登録API
            this.disabled_flg = true
            await axios.post('/shop/reservation/save', this.params).then(res => {
                if (res.data.success) {
                    this.slide.next('slideChanged', () => {
                        this.index = number
                    })
                } else {
                    this.disabled_flg = true
                    this.errors = res.data.errors
                }
            }).catch(e => {
                this.disabled_flg = true
                console.log('Error', e)
            })
        },
        checkValidation() {
            // 必須チェック
            this.errors = {}

            // クーポンを使用する場合はクーポンを選択
            if (this.coupon_flg === 'true') {
                if (!this.params.coupon_id) {
                    this.errors.coupon_id = ['クーポンを選択してください']
                } else {
                    // クーポン名を取得
                    const res = this.coupons.find((u) => u.id === this.params.coupon_id)
                    this.coupon_title = res.title
                }
            } else {
                this.params.coupon_id = ''
            }
            // 予約人数
            if (!this.params.number) {
                this.errors.number = ['予約人数を選択してください']
            }
            // 第一希望予約日時
            if (!this.params.first_selected_date || !this.params.first_selected_time) {
                this.errors.first_selected_date = ['日時を選択してください']
                this.errors.first_selected_time = ['日時を選択してください']
            } else {
                // 設定
                this.params.first_preferred_date = this.params.first_selected_date + ' ' + this.params.first_selected_time
            }
            // 第二希望予約日時
            if (this.params.second_selected_date || this.params.second_selected_time) {
                if (!this.params.second_selected_date) {
                    this.errors.second_selected_date = ['日時を選択してください']
                } else if (!this.params.second_selected_time) {
                    this.errors.second_selected_date = ['日時を選択してください']
                } else {
                    // 設定
                    this.params.second_preferred_date = this.params.second_selected_date + ' ' + this.params.second_selected_time
                }
            }
            // 氏名
            if (!this.params.last_name || !this.params.first_name) {
                this.errors.name = ['氏名を入力してください']
            } else {
                if (this.params.last_name && this.params.last_name.length > 255 ||
                    this.params.first_name && this.params.first_name.length > 255) {
                    this.errors.name = ['氏名は255文字以下で入力してください']
                }
            }
            // 氏名(ローマ字)
            if (!this.params.last_name_romaji || !this.params.first_name_romaji) {
                this.errors.name_romaji = ['氏名(ローマ字)を入力してください']
            } else {
                if (!this.romajiFormatCheck(this.params.last_name_romaji) || !this.romajiFormatCheck(this.params.first_name_romaji)) {
                    this.errors.name_romaji = ['氏名(ローマ字)は半角英字で入力してください']
                } else if (this.params.last_name_romaji && this.params.last_name_romaji.length > 255 ||
                    this.params.first_name_romaji && this.params.first_name_romaji.length > 255) {
                    this.errors.name_romaji = ['氏名(ローマ字)は255文字以下で入力してください']
                }
            }
            // 電話番号
            if (!this.params.tel) {
                this.errors.tel = ['電話番号を入力してください']
            } else if (this.params.tel.length > 255) {
                this.errors.tel = ['電話番号は255文字以下で入力してください']
            }
            // メールアドレス
            if (!this.params.email) {
                this.errors.email = ['メールアドレスを入力してください']
            } else if (this.params.email.length > 255) {
                this.errors.email = ['メールアドレスは255文字以下で入力してください']
            } else if (!this.emailFormatCheck(this.params.email)) {
                this.errors.email = ['メールアドレスの形式が正しくありません']
            }
            // メールアドレス(確認用)
            if (!this.email_confirmation) {
                this.errors.email_confirmation = ['メールアドレス(確認用)を入力してください']
            } else if (this.email_confirmation.length > 255) {
                this.errors.email_confirmation = ['メールアドレス(確認用)は255文字以下で入力してください']
            } else if(!this.emailFormatCheck(this.email_confirmation)) {
                this.errors.email_confirmation = ['メールアドレス(確認用)の形式が正しくありません']
            }
            if (this.params.email && this.email_confirmation) {
                if (this.params.email !== this.email_confirmation) {
                    this.errors.email_confirmation = ['メールアドレスとメールアドレス(確認用)が一致していません']
                }
            }
            // 宿泊先名
            if (!this.params.hotel_name) {
                this.errors.hotel_name = ['宿泊先を入力してください']
            } else if (this.params.hotel_name.length > 255) {
                this.errors.hotel_name = ['宿泊先は255文字以下で入力してください']
            }
            // その他のご希望
            if (this.params.other_request && this.params.other_request.length > 255) {
                this.errors.other_request = ['255文字以下で入力してください']
            }
            // 店舗からのお願い
            if (this.shop.request) {
                if (!this.request_flg) {
                    this.errors.request_flg = ['店舗からのお願いへの同意が必要です']
                }
            }

            if (!Object.keys(this.errors).length) {
                return true
            } else {
                return false
            }
        },
        romajiFormatCheck(val) {
            if (!/^[a-zA-Z]+$/.test(val)) {
                return false
            }
            return true
        },
        emailFormatCheck(val) {
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
                return false
            }
            return true
        }
    },
    watch: {
        show(val) {
            const searchNav = document.querySelector('.searchAndBottomTabNav')
            if (!val) {
                searchNav.classList.remove('reservationModalOpen')
                return
            } else {
                searchNav.classList.add('reservationModalOpen')
                this.$nextTick(() => {
                    this.initSlide(val)
                })
            }
        }
    }
}
</script>
